<template>
  <div class="wrap">
    <div class="top">
      <div class="notice">
        <img src="../../assets/images/payResult/sucessICON.png" alt />
        <span class="right">
          <span class="bold">权益卡领取成功</span>
          <span class="desc">多重优惠等你拿</span>
        </span>
      </div>
    </div>
    <div class="listWrap">
      <div class="item" style="border-bottom:1px solid #eee">
        <span class="left">权益卡号</span>
        <span class="right">{{aItem.card_number}}</span>
      </div>
      <div class="item">
        <span class="left">激活密码</span>
        <span class="right">{{aItem.password}}</span>
      </div>
    </div>
    <div class="bottom">
      <van-button class="btn red" @click="toOrder">查看权益记录</van-button>
      <!-- <van-button class="btn default" @click="toHome">回到首页</van-button> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
  export default {
    data() {
      return {
        aItem:{},
      };
    },
    computed: {
    ...mapGetters(["userInfo"]),
  },
    methods: {
      detail(){
        let toast = this.$toast({
          mask: false,
          duration: 0,
          type: "loading"
        });
        this.$commonPost({
          jydm: "flow_10104",
          flow_10104: {
            user_nbr: this.userInfo.nbr,
          }
        })
          .then(response => {
            this.aItem = response;
            toast.clear();
          })
          .catch(err => {
            this.$toast({
              message: err.message,
              duration: 2000
            });
          });
      },
      toOrder() {
        this.$router.replace({path: "/myEquity",});
      },
      toHome(){
        this.$router.replace({
          path: "/index",
        });
      }
    },
    mounted() {
      this.detail()
    }
  };
</script>

<style scoped lang='less'>
  .wrap {
    width: 100%;
    background: #f5f5f5;
    min-height: 100vh;
    position: relative;
  }
  .top {
    width: 100%;
    height: 2.16rem;
    background: #e52b25;
    padding-top: 0.01rem;
    position: relative;
  }
  .top .notice {
    margin-top: 0.58rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .top .notice img {
    width: 1.16rem;
    height: 1.16rem;
  }
  .top .notice .right {
    display: flex;
    flex-direction: column;
    color: #fff;
    margin-left: 0.18rem;
  }
  .top .notice .right .bold {
    font-size: 0.34rem;
    line-height: 0.48rem;
    font-weight: 600;
  }
  .top .notice .right .desc {
    margin-top: 0.06rem;
    font-size: 0.24rem;
    line-height: 0.33rem;
    font-weight: 500;
  }
  .listWrap {
    margin-top: .2rem;
    width: 100%;
    background: #fff;
    box-sizing: border-box;
    padding-left: .24rem;
  }
  .item{
    width: 100%;
    box-sizing: border-box;
    padding-right: .24rem;
    height: .96rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .left{
      font-size: .34rem;
      color: #333;
    }
    .right{
      font-size: .3rem;
      color: #999;
    }
  }
  
  .bottom {
    position: fixed;
    bottom: 0.5rem;
    display: flex;
    justify-content: center;
    padding: 0 0.38rem;
    box-sizing: border-box;
    width: 100%;
  }
  .bottom .btn {
    width: 3.3rem;
    height: 0.78rem;
    border-radius: 0.49rem;
    font-size: 0.26rem;
    font-weight: 500;
    border: 0;
    box-sizing: border-box;
    line-height: 1.5;
  }
  .bottom .btn.red {
    background: #e52b25;
    color: #fff;
  }
  .bottom .btn.default {
    border: 1px solid #e5e5e5;
    color: #333;
  }
</style>
<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/equity/equityResult.vue